import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from './Redux/authSlice';
import { RootState } from './Redux/store';

const AuthGuard = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state: RootState) => state.auth.value);
    const [isLoading, setIsLoading] = useState(true);

    const getCookie = (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    };

    useEffect(() => {
        const verifyAuth = async () => {
            // If reduxx says authenticated, we might trust it, but safer to check token presence
            if (isAuthenticated) {
                setIsLoading(false);
                return;
            }

            const token = getCookie('token');
            if (!token) {
                console.log('No token found, redirecting to login');
                dispatch(setAuth(false));
                setIsLoading(false);
                return;
            }

            // Verify token with backend
            try {
                // Using the /users/user endpoint as it is standard in this app for verifying role/auth
                await axios.get('/users/user', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                dispatch(setAuth(true));
            } catch (error) {
                console.error('Auth verification failed', error);
                dispatch(setAuth(false));
            } finally {
                setIsLoading(false);
            }
        };

        verifyAuth();
    }, [dispatch, isAuthenticated]);

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 w-100">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Verifying session...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default AuthGuard;
